import { useMutation, useQueryClient } from '@northladder/services';
import { IApiError } from '@northladder/utilities';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

import { TRANSFER_TRAY_LIST_QUERY_KEY } from './useTransferTrayListQuery';

/**
 * This is to track the mutation key for marking a tray as received
 */
const MUT_MARK_TRAY_RECEIVED = 'mark-tray-received-mutation';

export interface IMarkTrayAsReceivedPayload {
  inventoryTransferId: string;
  trayNumber: string;
}

interface IMarkTrayAsReceivedMutationParam {
  onError?: (err: IApiError) => void;
  onSuccess?: () => void;
}

/**
 * React Query mutation function for marking a tray as received in inventory transfer.
 */
export const useMarkTrayAsReceivedMutation = ({
  onError,
  onSuccess,
}: IMarkTrayAsReceivedMutationParam) => {
  const queryClient = useQueryClient();

  const { isPending, isError, error, data, mutate, isSuccess, reset } =
    useMutation({
      mutationKey: [MUT_MARK_TRAY_RECEIVED],
      networkMode: 'always',
      mutationFn: INV_MGMT_SERVICE_API.markTrayAsReceived,
      onError,
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [TRANSFER_TRAY_LIST_QUERY_KEY],
        });
        onSuccess?.();
      },
    });

  return {
    isMarkTrayReceivedError: isError,
    isMarkTrayReceivedOngoing: isPending,
    isMarkTrayReceivedSuccess: isSuccess,
    markTrayReceivedError: error,
    markTrayAsReceived: mutate,
    resetMarkTrayReceived: reset,
    data,
  };
};
